import { render, staticRenderFns } from "./Orgchart.vue?vue&type=template&id=ffc4b740"
import script from "./Orgchart.vue?vue&type=script&lang=js"
export * from "./Orgchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports